<template>
  <div style="margin-top: 70px; height: 100vh; background-color: #fafafa;">
    <img class="product-icon" :src="require('@/assets/review/' + productImgPath + '.png')">
    <p style="margin-bottom: 0;">{{productName}}</p>
    <transition name="fade">
      <section id="review-input" v-show="!isReviewInput">
        <p style="font-weight: bold; font-size: 20px; margin-bottom: 5px;">{{productName}}를 점수로 알려주세요</p>
        <star-rating :star-size="30" :rating="rating" @rating-selected="setRating"></star-rating>
        <p style="margin-top: 11px;">평균 평점: {{averageRating}}</p>
        <textarea v-model="reviewContents" placeholder="리뷰 작성하면 I/O Cash 15,000원 지급!"></textarea>
        <div class="footer-btn-container">
          <button @click="reviewInput">리뷰 등록하기</button>
        </div>
      </section>
    </transition>
    <transition name="fade">
      <section id="customer-input" v-show="isReviewInput">
        <div class="customer-info-container">
          <img
            class="person-icon"
            :src="require('@/assets/review/' + customerImgPath + '.png')"
            alt
          >
          <span v-show="isComplete">{{customerName}}</span>
          <star-rating :star-size="30" :show-rating="false" :rating="rating" read-only></star-rating>
        </div>
        <p v-if="isComplete">I/O Cash 지급 완료</p>
        <p style="font-size: 16px; font-weight:bold;" v-else>I/O Cash 지급을 위해 고객 인증이 필요합니다.</p>
        <p v-if="isAuthSent" style="margin: 0;">인증 번호</p>
        <p v-else style="margin: 0;">휴대폰 번호</p>
        <div class="input-container">
          <input v-if="isAuthSent" v-model="authNumber" type="text">
          <input v-else v-model="customerPhoneNumber" type="text">
          <button v-if="isAuthSent" @click="authenticate">{{authText}}</button>
          <button v-else @click="sendAuthNumber">인증번호 전송</button>
        </div>
      </section>
    </transition>
  </div>
</template>
<script>
import { isCellPhone } from '../../modules/modules.js'
import { IO_PRODUCTS_NAME, IO_PRODUCTS } from '../../modules/products.js'
const alertOptions = {title: '', size: 'sm', okLabel: '확인'}

export default {
  watch: {
    '$route': 'assignProductImage',
    'isComplete': 'changeIcon'
  },
  created () {
    this.assignProductImage()
  },
  mounted () {
    this.fetchReviewInfo()
  },
  methods: {
    fetchReviewInfo: function () {
      this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/reviews/state/?product_id=' + this.productId)
        .then((result) => {
          this.averageRating = result.data.avg.toFixed(1)
        })
    },
    sendAuthNumber: function () {
      if (this.customerPhoneNumber === '') {
        this.$dialogs.alert('이름을 먼저 입력해주세요!', alertOptions)
        return
      }
      if (!isCellPhone(this.customerPhoneNumber)) {
        this.$dialogs.alert('휴대폰번호를 확인해주세요!', alertOptions)
        return
      }
      if (!this.checkIsCustomer()) {
        this.$dialogs.alert('I/O 고객이 아니십니다.', alertOptions)
        return
      }
      let payload = new FormData()
      payload.append('phone_number', this.customerPhoneNumber)
      this.$http.post(process.env.URL_EVENT_SERVICE + '/v1/access-tokens/', payload)
        .then((result) => {
          if (result.status === 201) {
            this.$dialogs.alert('인증번호를 전송하였습니다.', alertOptions)
            this.accessTokenId = result.data.id
            this.isAuthSent = true
          } else {
            this.$dialogs.alert('인증번호 전송 실패! 고객센터에 문의해주세요.', alertOptions)
          }
        })
    },
    async checkIsCustomer () {
      await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/customers/?search=' + this.customerPhoneNumber)
        .then((result) => {
          if (result.status === 200) {
            // 고객이 아니면
            if (result.data.length === 0) {
              return false
            }
            this.customerId = result.data[0].id
            this.customerName = this.encryptName(result.data[0].name)
            return true
          }
        })
    },
    authenticate: function () {
      this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/access-tokens/' + this.accessTokenId + '/?authentication_number=' + this.authNumber)
        .then((result) => {
          if (result.status === 200) {
            this.$dialogs.alert('인증 완료', alertOptions)
            this.authText = '인증완료'
            this.isAuth = true
            this.enrollReview()
          } else {
            this.$dialogs.alert('인증번호를 다시 확인해주세요.', alertOptions)
          }
        })
    },
    enrollReview: function () {
      let payload = new FormData()
      payload.append('product_id', this.productId)
      payload.append('customer_id', this.customerId)
      payload.append('content', this.reviewContents)
      payload.append('rate', this.rating)
      this.$http.post(process.env.URL_EVENT_SERVICE + '/v1/reviews/', payload)
        .then((result) => {
          if (result.status === 201) {
            this.isComplete = true
            this.$dialogs.alert('리뷰 등록 완료', alertOptions)
          } else {
            this.$dialogs.alert('리뷰 등록 실패', alertOptions)
          }
        })
        .catch((error) => {
          if (error.response.data.code === 34) {
            this.$dialogs.alert('이미 사용종료된 제품은 리뷰를 등록할 수 없습니다.', alertOptions)
          } else {
            this.$dialogs.alert('리뷰를 등록할 수 없습니다.', alertOptions)
          }
          })
    },
    reviewInput: function () {
      if (this.reviewContents.length < 10) {
        this.$dialogs.alert('10자 이상 입력해주세요 !', alertOptions)
        return
      }
      if (this.reviewContents.length > 200) {
        this.$dialogs.alert('200자 이하로 입력해주세요 !', alertOptions)
        return
      }
      this.isReviewInput = true
      window.scrollTo(0, 0)
    },
    setRating: function (rating) {
      this.rating = rating
    },
    assignProductImage: function () {
      switch (this.$route.path) {
        case '/review/submit/' + IO_PRODUCTS.SWITCHER_ONE_BUTTON:
          this.productImgPath = 'switcher'
          this.productName = IO_PRODUCTS_NAME.SWITCHER_ONE_BUTTON
          this.productId = IO_PRODUCTS.SWITCHER_ONE_BUTTON
          break
        case '/review/submit/' + IO_PRODUCTS.SWITCHER_TWO_BUTTON:
          this.productImgPath = 'switcher'
          this.productName = IO_PRODUCTS_NAME.SWITCHER_TWO_BUTTON
          this.productId = IO_PRODUCTS.SWITCHER_TWO_BUTTON
          break
        case '/review/submit/' + IO_PRODUCTS.LINKER:
          this.productImgPath = 'linker'
          this.productName = IO_PRODUCTS_NAME.LINKER
          this.productId = IO_PRODUCTS.LINKER
          break
        case '/review/submit/' + IO_PRODUCTS.CHECKER:
          this.productImgPath = 'checker'
          this.productName = IO_PRODUCTS_NAME.CHECKER
          this.productId = IO_PRODUCTS.CHECKER
          break
      }
    },
    changeIcon: function () {
      this.customerImgPath = 'person-known'
    },
    encryptName: function (name) {
      const NUM_SHOW = 2
      var result = name.substring(0, NUM_SHOW)
      var csk = '*'
      for (var i = 0; i < name.length - NUM_SHOW; i++) {
        result = result.concat(csk)
      }
      return result
    }
  },
  data () {
    return {
      isReviewInput: false,
      isComplete: false,
      productImgPath: '',
      productName: '',
      productId: '',
      customerId: '',
      customerName: '',
      customerPhoneNumber: '',
      customerImgPath: 'person-unknown',
      averageRating: 0,
      rating: 5,
      reviewContents: '',
      isAuthSent: false,
      isAuth: false,
      accessTokenId: '',
      authNumber: '',
      authText: '인증'
    }
  }
}
</script>
<style scoped>
.active {
  display: block !important;
}
.header-banner {
  font-size: 16px;
  padding: 10px;
}

.person-icon {
  width: 40px;
}

.product-icon {
  width: 60px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.product-icon-customer {
  width: 60px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.vue-star-rating {
  display: inline-flex !important;
}
textarea {
  margin-top: 10px;
  margin-bottom: 30px;
  width: 90%;
  height: 100px;
  border: 1px solid rgb(209, 209, 209);
  -webkit-appearance: none;

}

textarea::-webkit-input-placeholder {
  line-height: 100px;
  text-align: center;
}

.footer-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 56px;
  z-index: 9999;
}

.footer-btn-container button {
  width: 95%;
  height: 100%;
  font-size: 16px;
  text-align: center;
  color: #ffffff;
  background-color: #6f97fa;
  text-decoration: none;
  border: 0;
  border-radius: 7px;
  outline: 0;
  cursor: pointer;
}

.customer-info-container {
  padding: 20px;
  display: inline-flex;
  width: 80%;
  justify-content: space-evenly;
  align-items: center;
  /* background-color: #fff; */
  /* box-shadow: 0 1px 1px 0 #e9ecee; */
  /* border: .5px solid #f1f5f7; */
}

.input-container {
  height: 50px;
}

.input-container button {
  width: 100px;
  border-radius: 2px;
  background-color: #dee2e5;
  font-size: 14px;
  letter-spacing: -.4px;
  color: #3d4953;
  border: 0;
  height: 100%;
}

input {
  width: 50%;
  border: 1px solid #eef0f1;
  border-radius: 2px;
  height: 100%;
  outline: none;
  -webkit-appearance: none;
}

.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/products/SubmitReview.vue